import Head from 'next/head';
import { useRouter } from 'next/router';
/**
 * Public canonical host. All Restworld sub-apps (worker, employer,
 * ambassador) declare their canonical to the marketing domain so Google
 * consolidates indexing on the public www.restworld.it surface — the
 * subdomains themselves should not appear in search results.
 *
 * If this ever changes, update this single constant; all sub-apps pick
 * it up via the shared `<CanonicalUrl />` component.
 */

import { jsx as _jsx } from "react/jsx-runtime";
var PUBLIC_HOST = 'https://www.restworld.it';
/**
 * Renders `<link rel="canonical">` pointing at the public marketing URL
 * for the current path. Mount once in each sub-app's `_app.tsx` so every
 * page gets a canonical by default.
 *
 * Per-page overrides: render your own
 * `<Head><link rel="canonical" key="canonical" href="..." /></Head>` in
 * the page component. The `key="canonical"` deduplication makes Next.js
 * keep only the last tag with that key, so the page-level override wins.
 *
 * Note on the `/en/` locale: `router.asPath` already includes the locale
 * prefix (e.g. `/en/cerco-lavoro`), and the marketing site's `vercel.json`
 * has matching rewrites for every `/en/*` path that proxy back to the
 * relevant sub-app. So the canonical `https://www.restworld.it/en/...` is
 * a real, served URL — no locale stripping needed.
 */

export function CanonicalUrl() {
  var router = useRouter();
  var path = router.asPath.split('?')[0].split('#')[0];
  var normalized = path === '/' ? '' : path;
  var href = "".concat(PUBLIC_HOST).concat(normalized);
  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("link", {
      rel: "canonical",
      href: href
    }, "canonical")
  });
}